import React from "react";

export default function ImageCarousel({ images, hotelName }) {
  const [current, setCurrent] = React.useState(0);
  if (!images || images.length === 0) return null;

  function prevImage(e) {
    e.stopPropagation();
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  }
  function nextImage(e) {
    e.stopPropagation();
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: 320,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        className="image"
        src={images[current]}
        alt={hotelName}
        style={{
          width: "100%",
          height: 320,
          objectFit: "cover",
          borderRadius: 8,
        }}
      />
      {images.length > 1 && (
        <>
          <button
            onClick={prevImage}
            style={{
              position: "absolute",
              left: 8,
              top: "50%",
              transform: "translateY(-50%)",
              background: "rgba(0,0,0,0.4)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: 32,
              height: 32,
              cursor: "pointer",
              fontSize: 20,
              zIndex: 2,
            }}
            aria-label="Previous image"
          >
            &#8592;
          </button>
          <button
            onClick={nextImage}
            style={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
              background: "rgba(0,0,0,0.4)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: 32,
              height: 32,
              cursor: "pointer",
              fontSize: 20,
              zIndex: 2,
            }}
            aria-label="Next image"
          >
            &#8594;
          </button>
          <div
            style={{
              position: "absolute",
              bottom: 8,
              left: "50%",
              transform: "translateX(-50%)",
              background: "rgba(0,0,0,0.4)",
              color: "#fff",
              borderRadius: 12,
              padding: "2px 10px",
              fontSize: 14,
            }}
          >
            {current + 1} / {images.length}
          </div>
        </>
      )}
    </div>
  );
}
